import React from 'react';
import { BarChart } from '@mui/x-charts';
import { fData } from 'src/utils/formatNumber';

// ----------------------------------------------------------------------

export default class StackedHorizontalBarChart extends React.Component {
    constructor(props) {
      super(props);
    }

    render() {

      let series = this.props.series || [];

      if (!series?.length) {
        return null;
      }

      const formatTooltip = (value) => {
        if (this.props.value_type === 'size') {
          return String(fData(value)).toUpperCase();
        }
        if (this.props.value_type === 'percentage') {
          return `${Number(value).toFixed(2)}%`;
        }
        return value;
      };

      return (
            <>
                <BarChart
                  layout='horizontal'
                  series={series.map(item => ({
                    ...item,
                    valueFormatter: formatTooltip
                  }))}
                  yAxis={[{ scaleType: 'band', data: this.props.labels ? this.props.labels : [], position: 'none' }]}
                  xAxis={[{ position: 'none' }]}
                  leftAxis={null}
                  bottomAxis={null}
                  height={80}
                  tooltip={{
                    trigger: 'item'
                  }}
                  slotProps={{
                    legend: {
                      position: { vertical: 'bottom', horizontal: 'left' },
                      labelStyle: { color: 'grey', fontWeight: 400 },
                      itemMarkHeight: 10
                    }
                  }}
                  margin={{ left: 0, right: 0, top: 0 }}
                />
            </>
      );
    }
  }